<template>
  <div class="container">
    <h1 class="mb-4">{{ colaborator.full_name }}</h1>

    <div class="details">
      <div class="details__head">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" data-toggle="tab" role="tab" href="#details">
              <fai icon="info"/>&nbsp;Generales
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" role="tab" href="#cuts">
              <fai icon="tasks"/>&nbsp;Cortes de Pago
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" role="tab" href="#accounts">
              <fai icon="address-book"/>&nbsp;Cuentas de ahorro
            </a>
          </li>
        </ul>
      </div>
      <div class="details__body mt-4">
        <div class="tab-content">
          <!--begin: Details -->
          <div id="details" class="tab-pane fade show active" role="tabpanel" v-if="colaborator.id">
            <div class="row">
              <div class="col-sm-6">
                <h4 class="m--font-info">Datos Generales</h4>
              </div>
              <div class="col-sm-6 text-right">
                <button class="btn btn-info" @click="goToEdit">
                  <fai :icon="['far','edit']"/> Editar
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-4">
                  <h5>Nombre</h5>
                  <span>{{ colaborator.name }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Apellido Paterno</h5>
                  <span>{{ colaborator.lastname_father }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Apellido Materno</h5>
                  <span>{{ colaborator.lastname_mother }}</span>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-4">
                  <h5>Correo electrónico</h5>
                  <span>{{ colaborator.email }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Teléfono</h5>
                  <span>{{ colaborator.telephone }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Puesto</h5>
                  <span>{{ colaborator.position }}</span>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-4">
                  <h5>Fecha de nacimiento</h5>
                  <span>{{ colaborator.dob | reverseDate }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Fecha de inicio</h5>
                  <span>{{ colaborator.start_date | reverseDate }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Estatus</h5>
                  <span>{{ colaborator.status }}</span>
              </div>
            </div>
            <hr class="mt-4"/>
            <div class="row">
                <div class="col-sm col-md col-lg">
                    <h4 class="m--font-info">Datos de ahorro</h4>
                </div>
                <div class="col-sm-6 text-right">
                  <button class="btn btn-info" @click="downloadStatement">
                    <fai :icon="['far','file']"/> Resumen Mensual
                  </button>
              </div>
            </div>
            <div class="row mt-4">
                <div class="col-sm-6">
                  <h5>Sueldo</h5>
                  <span>{{ colaborator.salary | formatCurrency}}</span>
                </div>
                <div class="col-sm-6">
                    <h5>Monto de Ahorro</h5>
                    <span>{{ colaborator.acumulated_amount | formatCurrency }}</span>
                </div>
            </div>
          </div>
          <!--end: Details -->
          <!--begin: Period Cuts -->
          <div id="cuts" class="tab-pane fade" role="tabpanel" v-if="colaborator.id">
            <sys-table :headers="cuts_headers"
                       :items="period_cuts"
                       title="Cortes de Pago"
                       create_route="cuts_create"
                       :create_route_params="{type: 'colaborator', id: colaborator.id}"
                       error_message="No se encontraron cortes"
                       title_icon="tasks"/>
          </div>
          <!--end: Cuts -->
          <!--begin: Accounts -->
          <div id="accounts" class="tab-pane fade" role="tabpanel" v-if="colaborator.id">
            <sys-table :headers="accounts_headers"
                       :items="accounts"
                       title="Cuentas de Ahorro"
                       create_route="account_create"
                       :create_route_params="{ type: 'account', id: colaborator.id }"
                       update_route="account_update"
                       :update_route_params="{ type: 'account' }"
                       error_message="No se encontraron cuentas"
                       title_icon="address-book"/>
          </div>
          <!--end: Accounts -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import colabsService from '@/services/colaborators'
import SysTable from '@/components/shared/Table'
import formatCurrency from '@/filters/formatCurrency'
import reverseDate from '@/filters/reverseDate'

export default {
  name: 'ColaboratorDetail',

  components: { SysTable },

  data () {
    return {
      colaborator: {},
      cuts_headers: [
        { text: 'Id', value: 'id' },
        { text: 'Fecha de Inicio', value: 'init_date', reverseDate },
        { text: 'Fecha de Fin', value: 'end_date', reverseDate },
        { text: 'Acción Inicial', value: 'init_action' },
        { text: 'Acción Final', value: 'end_action' },
        { text: 'Días calculados', value: 'days_calculated' },
        { text: 'Saldo Anterior', value: 'amount', filter: formatCurrency }
      ],
      period_cuts: [],
      accounts_headers: [
        { text: 'Id', value: 'id' },
        { text: 'Fecha de Inicio', value: 'start_date' },
        { text: 'Sueldo 100%', value: 'salary', filter: formatCurrency },
        { text: 'Porcentaje', value: 'percent' },
        { text: 'Aplica Extra', value: 'extra' },
        { text: 'Estatus', value: 'status' },
        { text: 'Valor Acción', value: 'action_value' },
        { text: 'Saldo Pasado', value: 'restore_amount', filter: formatCurrency },
        { text: 'Saldo Anterior', value: 'previous_amount', filter: formatCurrency },
        { text: 'Monto de Ahorro', value: 'amount', filter: formatCurrency }
      ],
      accounts: []
    }
  },
  created: function () {
    const id = this.$route.params.id
    colabsService.getAccountsList(id).then(res => {
      this.accounts = res.data
    })

    colabsService.getSavingsAccountsList(id).then(res => {
      this.period_cuts = res.data
    })

    colabsService.getById(id).then(res => {
      this.colaborator = res.data
    })
  },
  methods: {
    goToEdit () {
      const id = this.$route.params.id
      this.$router.push({ name: 'colaborator_update', params: { id } })
    },
    downloadStatement () {
      const id = this.$route.params.id
      colabsService.getStatement(id).then(res => {
        console.log(id)
        if (res.error) {
          this.error = res.error
        } else {
          this.error = null
          window.open(res.url, '_blank')
        }
      }).catch(err => {
        console.log(JSON.stringify(err.data))
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/colaborators/ColaboratorDetail.vue